import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
export function useQuery(initialQuery) {
  var _React$useState = React.useState(initialQuery),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      query = _React$useState2[0],
      setQuery = _React$useState2[1];

  return {
    value: query,
    add: add,
    remove: remove,
    reset: reset,
    sort: sort,
    text: text,
    set: setQuery
  };

  function add(index, bucket) {
    if (!(index in query.filters)) {
      var nextQuery = _objectSpread(_objectSpread({}, query), {}, {
        filters: _objectSpread(_objectSpread({}, query.filters), {}, _defineProperty({}, index, [bucket]))
      });

      setQuery(nextQuery);
      return nextQuery;
    } else {
      var filter = query.filters[index];

      if (!filter.includes(bucket)) {
        var _nextQuery = _objectSpread(_objectSpread({}, query), {}, {
          filters: _objectSpread(_objectSpread({}, query.filters), {}, _defineProperty({}, index, [].concat(_toConsumableArray(filter), [bucket])))
        });

        setQuery(_nextQuery);
        return _nextQuery;
      }
    }

    return query;
  }

  function remove(index, bucket) {
    if (index in query.filters) {
      var filter = query.filters[index];

      if (filter.length === 1) {
        var copy = _objectSpread({}, query.filters);

        delete copy[index];

        var nextQuery = _objectSpread(_objectSpread({}, query), {}, {
          filters: copy
        });

        setQuery(nextQuery);
        return nextQuery;
      } else {
        var bucketIndex = filter.indexOf(bucket);

        var _nextQuery2 = _objectSpread(_objectSpread({}, query), {}, {
          filters: _objectSpread(_objectSpread({}, query.filters), {}, _defineProperty({}, index, [].concat(_toConsumableArray(filter.slice(0, bucketIndex)), _toConsumableArray(filter.slice(bucketIndex + 1)))))
        });

        setQuery(_nextQuery2);
        return _nextQuery2;
      }
    }

    return query;
  }

  function reset() {
    setQuery(initialQuery);
    return initialQuery;
  }

  function sort(sortType) {
    var nextQuery = _objectSpread(_objectSpread({}, query), {}, {
      sortType: sortType
    });

    setQuery(nextQuery);
    return nextQuery;
  }

  function text(text) {
    var nextQuery = _objectSpread(_objectSpread({}, query), {}, {
      text: text
    });

    setQuery(nextQuery);
    return nextQuery;
  }
}